/*
 * Copyright (c) 2023 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
import React, {createContext, useState, useContext} from 'react';


// Typescript context interface, you don't need this if not // using TS
interface IContext {
    theme: string
    changeTheme(string): void
}

const Context = createContext<IContext>({
    theme: null,
    changeTheme: () => { },
});


const ThemeProvider: React.FC = ({ children }) => {
    const [theme, setTheme] = useState<string>('auto');
    const changeTheme = (newTheme) => {
      setTheme(newTheme);
    };

    return (
        <Context.Provider value={{ theme, changeTheme }}>
            {children}
        </Context.Provider>
    );
};
export const useTheme = () => useContext(Context);

export default ThemeProvider;
